import ArrowForward from '@mui/icons-material/ArrowForward'
import {
  ArrowForwardIconButton,
  GiftCardRedeemHeader,
  GiftCardRedeemText,
  GiftCardRedeemWelcome,
  GiftRedeemEntry,
  GiftRedeemTextField,
} from '../GiftCardReedemStyles'
import NextStepsVideoComponent from './NextStepsVideoComponent'
import { useContext, useEffect } from 'react'
import { ProfileContext } from 'src/consumer/context/ProfileContext'
import dayjs from 'dayjs'
import { logoutHandler } from 'src/consumer/services/loginLogoutHandlers'

export default function RedeemScreen({
  heading,
  subHeading,
  inputPlaceholder,
  imageLink,
  name,
  giftCardValue,
  setGiftCardValue,
  setSendRequest,
  disabled,
  stepsToRedeemVideoText,
  stepsToRedeemVideoLink,
  showStepsToRedeemVideo,
  submitLoading,
  setSubmitLoading,
  showFaqs,
  haveQuestionsOnClickFunc,
  blockRedemptionIfPremium,
  openAuthModalFunc,
}) {
  useEffect(() => {
    if (sessionStorage.getItem('triggerSubmitOnLoad')) {
      sessionStorage.removeItem('triggerSubmitOnLoad')
      if (giftCardValue) {
        setSendRequest(true)
      }
    }
    if (blockRedemptionIfPremium) {
      if (sessionStorage.getItem('openAuthModalAfterRefresh')) {
        sessionStorage.removeItem('openAuthModalAfterRefresh')
        openAuthModalFunc && openAuthModalFunc()
      }
    }
  }, [])

  const { profileData } = useContext(ProfileContext)

  return (
    <>
      {' '}
      <>
        {imageLink && <img alt="company logo" src={imageLink} style={{ width: '140px' }} />}
        <GiftCardRedeemWelcome>{heading || `Welcome ${name}`}</GiftCardRedeemWelcome>
        <GiftCardRedeemHeader color="#FFFFFF">
          {subHeading || 'Redeem Your Giftcard'}
        </GiftCardRedeemHeader>
        <GiftCardRedeemText>
          {'Enjoy your inner-self on this journey to reset, heal and grow.'}
        </GiftCardRedeemText>
        {blockRedemptionIfPremium && profileData?.subscriptionType?.id === 'subscription_normal' && (
          <div>
            <div style={{ color: '#64e3a1' }}>
              Account Already Premium. Membership valid till{' '}
              {moment.unix(profileData?.subscriptionEndDate)?.format('MMMM D, YYYY')}
            </div>
            <div
              style={{ color: '#fff', textAlign: 'center', cursor: 'pointer' }}
              onClick={() => {
                logoutHandler()
                sessionStorage.setItem('openAuthModalAfterRefresh', true)
                window.location.reload()
              }}
            >
              <u>Sign in with a different account?</u>
            </div>
          </div>
        )}
        <GiftRedeemEntry>
          <GiftRedeemTextField
            placeholder={inputPlaceholder || 'Enter giftcard number here'}
            onChange={(event) => setGiftCardValue(event.target.value)}
            value={giftCardValue}
            disabled={disabled}
            InputProps={{
              endAdornment:
                giftCardValue === '' ? null : (
                  <ArrowForwardIconButton onClick={() => setSendRequest(true)}>
                    <ArrowForward />
                  </ArrowForwardIconButton>
                ),
            }}
          />
        </GiftRedeemEntry>
        {/* if submitLoading -> instead of arrow i want a button in the input box right side - which also has loading spinner */}

        {showStepsToRedeemVideo && (
          <div
            style={{
              maxWidth: '1200px',
              width: '100%',
              margin: '0px 10px',
            }}
          >
            <NextStepsVideoComponent
              buttonText={stepsToRedeemVideoText}
              videoLink={stepsToRedeemVideoLink}
            />
          </div>
        )}

        {showFaqs && haveQuestionsOnClickFunc && (
          <h5
            className="m-0"
            style={{
              textDecoration: 'underline',
              textAlign: 'center',
              color: '#d2d2d2',
              fontSize: '16px',
              cursor: 'pointer',
            }}
            onClick={haveQuestionsOnClickFunc}
          >
            Have Questions?
          </h5>
        )}
      </>
    </>
  )
}
